import {
  CONTENT_FITNESS_DIMENSIONS,
  type ContentFitnessDimension,
} from "./dimensions";
import {
  CONTENT_FITNESS_PILOT_SUBCRITERIA,
  CONTENT_FITNESS_SUBCRITERIA,
  type ContentFitnessSubcriterion,
} from "./subcriteria";

export function contentFitnessDimensionForKey(
  key: string,
): ContentFitnessDimension | null {
  return (
    CONTENT_FITNESS_DIMENSIONS.find((dimension) => dimension.key === key) ??
    null
  );
}

export function contentFitnessSubcriterionForKey(
  key: string,
): ContentFitnessSubcriterion | null {
  return CONTENT_FITNESS_SUBCRITERIA.find((item) => item.key === key) ?? null;
}

export function contentFitnessPilotSubcriteriaForDimension(
  parentMetricKey: string,
): ContentFitnessSubcriterion[] {
  return CONTENT_FITNESS_PILOT_SUBCRITERIA.filter(
    (item) => item.parentMetricKey === parentMetricKey,
  );
}

export function contentFitnessCanonicalCountForDimension(
  parentMetricKey: string,
): number {
  return CONTENT_FITNESS_SUBCRITERIA.filter(
    (item) => item.parentMetricKey === parentMetricKey,
  ).length;
}
